module.exports = __webpack_public_path__ + "img/enjoyAnalyze.540bcebb.png";